import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navigation from './Components/Navigation/Navigation';
import Home from './Pages/Public/Home/Home';
import NavigationPublicList from './Data/NavigationPublic.json';
import NavigationPrivateList from './Data/NavigationPrivate.json';
import { useRecoilState } from 'recoil';
import { loadingState, modalState } from './Recoil/Atoms';
import Loader from './Components/Loader/Loader';
// import Editor from './Pages/Private/Editor/Editor';
import Modal from './Components/Modal/Modal';
import { setRecoilModalSetter } from './Services/api.service';
import About from './Pages/Public/About/About';
import Contact from './Pages/Public/Contact/Contact';
// import Properties from './Pages/Public/Properties/Properties';
// import PropertyDetail from './Pages/Public/PropertyDetail/PropertyDetail';
import ServiceDetail from './Pages/Public/ServiceDetail/ServiceDetail';
import Services from './Pages/Public/Services/Services';
import Privacy from './Pages/Public/Privacy/Privacy';
import Login from './Pages/Public/Login/Login';
import BecomeTenant from './Pages/Public/BecomeTenant/BecomeTenant';
// import Viewer from './Pages/Private/Viewer/Viewer';
import ForgotPass from './Pages/Public/ForgotPass/ForgotPass';
// import Editor from './Pages/Private/Editor/Editor';
// import TenantDashboard from './Pages/Private/Tenant/Dashboard/Dashboard';
// import PropertyEditor from './Pages/Private/Property/PropertyEditor';

const App = () => {
    const [loading, ] = useRecoilState(loadingState);
    const [modal, setModalState] = useRecoilState(modalState);

    useEffect(() => {
        setRecoilModalSetter(setModalState);
    }, [setModalState]);

    const MainLayout = () => {
        const { pathname } = useLocation();

        useEffect(() => {
            window.scrollTo(0, 0);
        }, [pathname]);

        return (
            <>
                <Navigation menuItems={NavigationPublicList} isPrivate={false} />
                <Outlet />
            </>
        );
    };

    const PrivateLayout = () => (
        <>
            <Navigation menuItems={NavigationPrivateList} isPrivate={true} />
            <Outlet />
        </>
    );

    return (
        <Router>
            {loading ? (
                <Loader />
            ) : (
                <>
                    {modal.isOpen && <Modal message={modal.message} />}
                    <Routes>
                        {/* <Route element={<PrivateLayout />}>
                            <Route path='admin/properties/:id' element={<PropertyEditor />} />
                            <Route path='tenant/dashboard' element={<TenantDashboard />} />
                            <Route path=':role/:title/:id' element={<Editor />} />
                            <Route path=':role/:title' element={<Viewer />} />
                        </Route> */}
                        <Route element={<MainLayout />}>
                            <Route path='become-tenant' element={<BecomeTenant />} />
                            <Route path='privacy' element={<Privacy />} />
                            <Route path='service/:id' element={<ServiceDetail />} />
                            <Route path='services' element={<Services />} />
                            {/* <Route path='property/:id' element={<PropertyDetail />} />
                            <Route path='properties' element={<Properties />} /> */}
                            <Route path='contact' element={<Contact />} />
                            <Route path='about' element={<About />} />
                            <Route path='/' element={<Home />} />
                            {/* <Route path='*' element={<NotFound />} /> */}
                        </Route>
                        <Route path='reset-password/:uid/:token' element={<ForgotPass />} />
                        <Route path='login' element={<Login />} />
                    </Routes>
                </>
            )}
        </Router>
    );
};

export default App;
